import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getUserInstances } from '../api/services/instancesService';

import { useInstanceId } from './useInstanceId';

export function useCurrentCustomerName(): string | undefined {
  const { instanceId } = useInstanceId();
  const { data } = useQuery({
    queryKey: ['user-instances'],
    queryFn: getUserInstances,
    staleTime: 5 * 60 * 1000,
  });
  return useMemo(() => {
    const match = data?.find(i => i.instance_id === instanceId);
    return match?.customer_name || undefined;
  }, [data, instanceId]);
}
